import {AxiosInstance, AxiosResponse} from "axios";
import {Version} from "@/core/interfaces/version/Version";

/**
 * The version resource.
 *
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client: AxiosInstance) {
    return {
        /**
         * Tell if the version is highlighted.
         */
        async isHighlight(version: string): Promise<Version | { message: string }> {
            return client.get(`/highlight-version`, {params: {version}})
                .then((response: AxiosResponse) => response.data.data);
        }
    };
}
